<template>
  <div id="container" class="mainBox">
    <nyTit pathUrl="/binghai" :nextShow="true" />
    <h5 class="h5">作物生长指导模型</h5>
    <div class="content">
      <div class="left flex_column">
        <div class="guidance-left-top">
          <GuidanceModelArchitecture />
          <GuidanceEnvironmentJudgement />
          <GuidanceAdvicePanel />
        </div>
        <GuidanceRegionGuideList />
      </div>
      <div class="center flex_column">
        <section class="guidance-center">
          <GuidanceCenterHeader />
          <div class="guidance-engine">
            <GuidanceEnvironmentMonitor />
            <GuidanceCenterOrbit />
            <GuidanceStressResult />
          </div>
          <GuidanceLoopPanel />
        </section>
      </div>
      <div class="right flex_column">
        <div class="subTit1"><span>智能种植模型</span></div>
        <div class="rightInfo">
          <div class="right_l flex_column">
            <div class="subTit2"><span>种植模型数据采集</span></div>
            <div class="t_down">
              <div class="t_d_t">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择区域:</h6>
                  <div class="srk">河南省驻马店市上蔡县</div>
                </div>
              </div>
              <div class="t_d_b">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择分类:</h6>
                  <div class="srk">小麦</div>
                </div>
              </div>
              <div class="t_d_d">
                <div class="t_d_t_jz">
                  <span></span>
                  <h6>选择品种:</h6>
                  <div class="srk">郑麦1860</div>
                </div>
              </div>
              <div class="t_d_d1">
                <div class="t_d_d1_l">
                  <h5>地块管理</h5>
                  <div class="d1_xtb"></div>
                </div>
                <div class="t_d_d1_r" @click="clickFangan">
                  <h5>生成方案</h5>
                  <div class="d1_xtb"></div>
                </div>
              </div>
            </div>
            <div class="t_bottom">
              <div
                class="t_bottom_item"
                v-for="(item, index) in state.rightVideo"
                :key="item.code + index"
                @click="videoClick(index)"
              >
                <img :src="item.img" />
              </div>
            </div>
          </div>
          <div class="right_r flex_column">
            <div class="subTit2"><span>种植数据方案</span></div>
            <div class="right_r_box1 flex_column">
              <div class="l_t_d_m">
                <div
                  class="l_t_d_m_g"
                  :class="{ l_t_d_m_g_cur: state.right_r_dataCur === index }"
                  v-for="(item, index) in state.right_r_data"
                  :key="item.name"
                  @click="leftTab1(index)"
                >
                  {{ item.name }}
                </div>
              </div>
              <div class="scrollTable">
                <dv-scroll-board
                  :config="state.right_r_data[state.right_r_dataCur].config"
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
            <div class="right_r_box2 flex_column">
              <div class="right_r_box2_item1">
                <h4>模型结论</h4>
                <div class="txt1" v-html="state.right_r_data2"></div>
              </div>
              <div class="right_r_box2_item2 flex_column">
                <h4>专家建议</h4>
                <div class="txt2">
                  <span v-for="item in state.right_r_data3" :key="item">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="popBg animate__animated animate__zoomIn" @click.stop="hiddlen" v-if="state.faSHow">
    <div class="faCon" @click.stop>
      <div class="close" @click.stop="hiddlen">x</div>
      <div class="faInfo">
        <dv-scroll-board :config="state.config" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>

  <popBg
    v-if="state.popShow"
    :title="state.rightVideo[state.curVideoIndex].name"
    :code="state.rightVideo[state.curVideoIndex].code"
    :popShow="state.popShow"
    @hiddlen="popHiddlen"
  >
    <div style="width: 100%; height: 100%">
      <iframe
        :src="state.rightVideo[state.curVideoIndex].options.src + state.AccessToken"
        width="100%"
        height="100%"
        id="ysOpenDevice"
        allowfullscreen
      ></iframe>
    </div>
  </popBg>
</template>

<script setup>
import { onMounted, reactive } from "vue";
import nyTit from "@/components/nyTit";
import popBg from "@/components/popBg.vue";
import GuidanceAdvicePanel from "@/components/cropGrowthGuidanceModel/GuidanceAdvicePanel.vue";
import GuidanceCenterHeader from "@/components/cropGrowthGuidanceModel/GuidanceCenterHeader.vue";
import GuidanceCenterOrbit from "@/components/cropGrowthGuidanceModel/GuidanceCenterOrbit.vue";
import GuidanceEnvironmentJudgement from "@/components/cropGrowthGuidanceModel/GuidanceEnvironmentJudgement.vue";
import GuidanceEnvironmentMonitor from "@/components/cropGrowthGuidanceModel/GuidanceEnvironmentMonitor.vue";
import GuidanceLoopPanel from "@/components/cropGrowthGuidanceModel/GuidanceLoopPanel.vue";
import GuidanceModelArchitecture from "@/components/cropGrowthGuidanceModel/GuidanceModelArchitecture.vue";
import GuidanceRegionGuideList from "@/components/cropGrowthGuidanceModel/GuidanceRegionGuideList.vue";
import GuidanceStressResult from "@/components/cropGrowthGuidanceModel/GuidanceStressResult.vue";

const state = reactive({
  faSHow: false,
  popShow: false,
  curVideoIndex: 0,
  AccessToken: "",
  config: {
    header: [
      '<span style="color:#fff;">农情</span>',
      '<span style="color:#fff;">项目</span>',
      '<span style="color:#fff;">记录</span>',
    ],
    data: [
      ["10-15", "土壤检测", "完成土壤养分、墒情和整地质量检测"],
      ["10-20", "整地施肥", "旋耕镇压，底施复合肥和有机肥，保障出苗基础"],
      ["10-25", "适期播种", "选择半冬性品种，播深3-5cm，亩播量按墒情调整"],
      ["11-10", "出苗巡查", "核查缺苗断垄，弱苗地块及时补苗补墒"],
      ["02-20", "返青管理", "返青期看苗追肥，弱苗区补施尿素"],
      ["03-15", "拔节调控", "控制旺长，保持群体通风透光"],
      ["04-20", "一喷三防", "抽穗扬花期重点防控赤霉病、条锈病和蚜虫"],
      ["05-15", "灌浆防护", "防干热风、防倒伏，保持后期叶片功能"],
      ["06-05", "成熟收获", "籽粒含水率适宜时机械收获并及时入仓"],
    ],
    headerBGC: "#15364D",
    oddRowBGC: "",
    evenRowBGC: "",
    index: false,
    columnWidth: [200, 200],
    align: ["center", "center", "left"],
    rowNum: 12,
  },
  rightVideo: [
    {
      name: "黄埠镇",
      img: require("../assets/img/xiaomai/img1.jpg"),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=",
      },
      code: "AZ8538489",
    },
    {
      name: "无量寺乡",
      img: require("../assets/img/xiaomai/img2.jpg"),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538131/2.live&autoplay=1&accessToken=",
      },
      code: "AZ8538131",
    },
    {
      name: "塔桥镇",
      img: require("../assets/img/xiaomai/img3.jpg"),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538131/1.live&autoplay=1&accessToken=",
      },
      code: "AZ8538131",
    },
    {
      name: "崇礼乡",
      img: require("../assets/img/xiaomai/img4.jpg"),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502097/1.live&autoplay=1&accessToken=",
      },
      code: "FB2502097",
    },
  ],
  right_r_data: [
    {
      name: "生长记录",
      config: {
        header: [
          '<span style="color:#fff;">农情</span>',
          '<span style="color:#fff;">项目</span>',
          '<span style="color:#fff;">记录</span>',
        ],
        data: [
          ["10-18", "整地施肥", "灭茬、旋耕、镇压完成，底肥按地力分区施用"],
          ["10-25", "播种", "小麦适墒机播，播深3-5cm，确保行距一致"],
          ["11-08", "出苗巡查", "出苗整齐度良好，缺苗断垄区域完成补种"],
          ["12-05", "越冬管理", "冬前群体适中，弱苗地块补水保墒"],
          ["02-24", "返青追肥", "返青期结合墒情追施尿素，促进分蘖成穗"],
          ["03-18", "拔节管理", "控制旺长，关注倒伏风险和茎基腐病"],
          ["04-20", "一喷三防", "抽穗扬花期防控赤霉病、条锈病和蚜虫"],
          ["05-18", "灌浆巡查", "重点防干热风、穗蚜和早衰，保持灌浆强度"],
        ],
        headerBGC: "#274547",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200, 200],
        align: ["center", "center", "center"],
      },
    },
    {
      name: "种植方案",
      config: {
        header: [
          '<span style="color:#fff;">日期</span>',
          '<span style="color:#fff;">农事</span>',
          '<span style="color:#fff;">具体操作</span>',
        ],
        data: [
          ["10-15", "播前准备", "完成土壤检测、种子包衣和底肥方案确认"],
          ["10-20", "精细整地", "深松旋耕、耙平镇压，保证土壤上虚下实"],
          ["10-25", "适期播种", "墒情适宜时机播，播深3-5cm，播后镇压"],
          ["11-10", "查苗补苗", "识别缺苗断垄，弱苗区及时补苗补水"],
          ["02-25", "返青追肥", "结合墒情追施氮肥，促进弱苗转壮"],
          ["03-15", "拔节调控", "旺苗区控旺，群体不足地块补肥促蘖"],
          ["04-20", "病虫防控", "抽穗扬花期执行一喷三防，重点防赤霉病"],
          ["05-20", "灌浆防护", "防干热风、防倒伏，必要时补施叶面肥"],
          ["06-05", "适时收获", "籽粒成熟后机械收获，及时晾晒入仓"],
        ],
        headerBGC: "#274547",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        align: ["center", "center", "center"],
        rowNum: 6,
      },
    },
  ],
  right_r_dataCur: 0,
  right_r_data2:
    "当前小麦模型数据按照冬小麦全生育期构建，重点覆盖播前整地、适墒播种、返青拔节、水肥协同、一喷三防、灌浆防护和适时收获。模型判断当前方案适合作为小麦季标准管理链路，夏季阶段不再安排小麦追肥、化控和收获任务。",
  right_r_data3: [
    "一、10月中下旬适墒播种",
    "二、返青拔节期水肥协同",
    "三、抽穗扬花期一喷三防",
    "四、灌浆后期防干热风倒伏",
  ],
});

function leftTab1(index) {
  state.right_r_dataCur = index;
}

function videoClick(index) {
  state.popShow = true;
  state.curVideoIndex = index;
}

function popHiddlen() {
  state.popShow = false;
}

function hiddlen() {
  state.faSHow = false;
}

function clickFangan() {
  state.faSHow = true;
}

onMounted(() => {
  state.AccessToken = localStorage.getItem("AccessToken") || "";
});
</script>

<style lang="less" scoped>
.flex_column {
  display: flex;
  flex-direction: column;
}

.h5 {
  position: absolute;
  top: 130px;
  left: 140px;
  z-index: 999;
  font-size: 40px;
  color: #f3fcff;
  letter-spacing: 5px;
  text-align: left;
  text-shadow: 0 0 5px rgba(21, 241, 187, 0.5),
    0 0 10px rgba(21, 241, 187, 0.8),
    0 0 20px rgba(21, 241, 187, 1);
}

.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  display: flex;

  .content {
    width: 100%;
    height: calc(100% - 100px);
    position: absolute;
    top: 100px;
    display: flex;
    padding: 0 30px 100px;
    box-sizing: border-box;

    .subTit1 {
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/bt.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;

      span {
        background: linear-gradient(to bottom, #fff 25%, #ffd791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
    }

    .subTit2 {
      width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png") no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254, 254, 254, 1);
      box-sizing: border-box;
    }

    .left,
    .right {
      width: 2173px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      background: #071315;
    }

    .left {
      padding: 180px 70px 18px;
      gap: 34px;
      position: relative;
      overflow: hidden;
      color: #fff;
      background:
        radial-gradient(circle at 50% 10%, rgba(32, 255, 226, 0.1), transparent 42%),
        #071315;

      &::before {
        content: "";
        position: absolute;
        inset: 0;
        background:
          linear-gradient(rgba(54, 255, 236, 0.035) 1px, transparent 1px),
          linear-gradient(90deg, rgba(54, 255, 236, 0.03) 1px, transparent 1px);
        background-size: 42px 42px;
        pointer-events: none;
      }

      .guidance-left-top {
        position: relative;
        z-index: 1;
        min-height: 0;
        flex: 1;
        display: grid;
        grid-template-columns: 410px minmax(0, 1fr) 410px;
        gap: 32px;
      }
    }

    .center {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 180px;
      box-sizing: border-box;
      min-width: 0;
      color: #fff;

      .guidance-center {
        position: relative;
        height: 100%;
        display: grid;
        grid-template-rows: 132px minmax(0, 1fr) 198px;
        padding: 0 0 26px;
        box-sizing: border-box;
        overflow: hidden;
      }

      .guidance-center::before {
        content: "";
        position: absolute;
        inset: 94px 24px 24px;
        z-index: 0;
        border: 1px solid rgba(70, 255, 238, 0.08);
        background:
          linear-gradient(180deg, rgba(0, 16, 15, 0.16), rgba(0, 53, 45, 0.34)),
          url("../assets/img/mxbg.jpg") center bottom / cover no-repeat;
        opacity: 0.72;
        pointer-events: none;
      }

      .guidance-center::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 0;
        background:
          radial-gradient(circle at 78% 12%, rgba(21, 255, 229, 0.22), transparent 30%),
          linear-gradient(180deg, rgba(0, 0, 0, 0.58), transparent 42%, rgba(0, 0, 0, 0.14));
        pointer-events: none;
      }

      .guidance-engine {
        position: relative;
        z-index: 1;
        min-height: 0;
        display: grid;
        grid-template-columns: 420px minmax(560px, 1fr) 420px;
        gap: 34px;
        align-items: center;
      }
    }

    .right {
      padding: 0 70px;

      .rightInfo {
        display: flex;
        width: 100%;
        flex: 1;

        .right_l,
        .right_r {
          flex: 1;
          height: 100%;
        }

        .right_l {
          justify-content: space-between;

          .t_down {
            width: 100%;
            display: flex;
            flex-direction: column;

            .t_d_t_jz {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;

              h6 {
                width: 180px;
                height: 108px;
                font-size: 30px;
                color: #fff;
                text-align: left;
                line-height: 108px;
                letter-spacing: 5px;
                margin: 0 20px 0 0;
                font-weight: normal;
              }

              .srk {
                width: 706px;
                height: 108px;
                background: url("../assets/img/xiaomai/xzk.png") no-repeat;
                background-size: 100% 100%;
                overflow: hidden;
                font-size: 32px;
                color: #fff;
                line-height: 108px;
                text-align: left;
                letter-spacing: 4px;
                text-indent: 2em;
                white-space: nowrap;
              }
            }

            .t_d_t {
              width: 100%;
              height: 108px;

              span {
                width: 40px;
                height: 45px;
                background: url("../assets/img/xiaomai/qy.png") no-repeat top center;
                background-size: 100% 100%;
                font-size: 30px;
                margin-right: 20px;
                flex-shrink: 0;
              }
            }

            .t_d_b {
              width: 100%;
              height: 108px;
              margin: 30px 0;

              span {
                width: 40px;
                height: 40px;
                background: url("../assets/img/xiaomai/pl.png") no-repeat top center;
                font-size: 30px;
                margin-right: 20px;
                flex-shrink: 0;
              }
            }

            .t_d_d {
              width: 100%;
              height: 108px;
              margin: 10px 0;
              position: relative;

              span {
                width: 49px;
                height: 46px;
                background: url("../assets/img/xiaomai/pz.png") no-repeat top center;
                background-size: 100% 100%;
                margin-right: 20px;
                flex-shrink: 0;
              }
            }

            .t_d_d1 {
              width: 100%;
              height: 108px;
              margin-top: 65px;
              display: flex;
              justify-content: center;
              align-items: center;

              h5 {
                width: 160px;
                height: 80px;
                font-size: 30px;
                color: #fff;
                text-align: left;
                line-height: 80px;
                letter-spacing: 4px;
                margin: 0 40px 0 0;
                font-weight: normal;
              }

              .t_d_d1_l {
                width: 395px;
                height: 100%;
                background: url("../assets/img/xiaomai/dkk.png") no-repeat top center;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .d1_xtb {
                  width: 56px;
                  height: 57px;
                  background: url("../assets/img/xiaomai/dk.png") no-repeat top center;
                  background-size: 100% 100%;
                }
              }

              .t_d_d1_r {
                width: 393px;
                height: 100%;
                background: url("../assets/img/xiaomai/dkk.png") no-repeat top center;
                background-size: 100% 100%;
                display: flex;
                margin-left: 100px;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .d1_xtb {
                  width: 60px;
                  height: 57px;
                  background: url("../assets/img/xiaomai/sc.png") no-repeat top center;
                  background-size: 100% 100%;
                }
              }
            }
          }

          .t_bottom {
            width: 100%;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-end;

            .t_bottom_item {
              width: 478px;
              height: 274px;
              background: url("../assets/img/xiaomai/spk.png") no-repeat;
              padding: 5px;
              box-sizing: border-box;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }

        .right_r {
          justify-content: space-between;
          padding-left: 100px;
          box-sizing: border-box;

          .right_r_box1 {
            height: 50%;
            padding: 0 30px;
            box-sizing: border-box;

            .l_t_d_m {
              width: 100%;
              height: 79px;
              display: flex;
              justify-content: center;

              .l_t_d_m_g {
                width: 230px;
                height: 79px;
                font-size: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: url("../assets/img/xiaomai/szjl.png") no-repeat top center;
                background-size: 100% 100%;
                cursor: pointer;
                margin: 5px 30px 0;
              }

              .l_t_d_m_g_cur {
                color: #23fff2;
              }
            }

            .scrollTable {
              width: 100%;
              flex: 1;
              margin-top: 30px;

              ::v-deep .dv-scroll-board .rows .row-item {
                font-size: 30px;
                border: 4px solid transparent;
                border-left: 0;
                border-bottom: 0;
                border-image: linear-gradient(
                    to right,
                    rgba(34, 41, 42, 0) 10%,
                    rgba(34, 41, 42, 1) 20%,
                    rgba(34, 41, 42, 1) 50%,
                    rgba(34, 41, 42, 1) 80%,
                    rgba(34, 41, 42, 0)
                  )
                  4;
              }
            }
          }

          .right_r_box2 {
            width: 100%;
            flex: 1;
            padding-top: 60px;
            justify-content: space-between;
            box-sizing: border-box;

            h4 {
              width: 100%;
              height: 50px;
              background: url("../assets/img/xiaomai/mx.png") no-repeat left bottom;
              line-height: 40px;
              font-size: 30px;
              color: #fff;
              text-align: left;
              padding-left: 40px;
              box-sizing: border-box;
              margin: 0;
              font-weight: normal;
            }

            .right_r_box2_item1 {
              .txt1 {
                font-size: 26px;
                color: #fff;
                text-align: left;
                line-height: 40px;
                padding: 20px 30px;
                text-indent: 2em;
              }
            }

            .right_r_box2_item2 {
              .txt2 {
                width: 100%;
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;

                span {
                  display: block;
                  width: 356px;
                  height: 73px;
                  line-height: 73px;
                  background: #08292c;
                  color: #fff;
                  font-size: 26px;
                  text-align: left;
                  margin: 20px 50px;
                  padding: 0 30px;
                  box-sizing: border-box;
                }
              }
            }
          }
        }
      }
    }
  }
}

.popBg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all 0.5s ease-out;

  .faCon {
    width: 50%;
    height: 70%;
    position: absolute;
    top: 15%;
    left: 25%;
    background: #102130;
    border: 2px solid #16616a;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 50px;
    box-sizing: border-box;
    align-items: center;
    overflow-y: auto;

    .close {
      color: rgba(255, 255, 255, 0.8);
      font-size: 60px;
      position: absolute;
      top: 20px;
      right: 26px;
      cursor: pointer;
    }

    .faInfo {
      width: 90%;
      flex: 1;
      margin-top: 30px;
      font-size: 14px;
    }
  }
}

::v-deep .dv-scroll-board .header {
  display: flex;
  flex-direction: row;
  font-size: 30px;
  background: url("../assets/img/xiaomai/nq.png") no-repeat top center;
  background-size: 100% 100%;
  height: 70px;
  justify-content: center;
  align-items: center;
  border: 0;
}

::v-deep .dv-scroll-board .rows .row-item {
  font-size: 30px;
}
</style>
